import React, {useEffect, useState} from 'react';
import {db} from "../../services/firebase";
import i18next from "i18next";
import {NotificationContainer} from './notifications-menu.styles';

const NotificationsMenu = () => {

    const [notifications, setNotifications] = useState([])

    useEffect(() => {
        (async () => {
            try {
                db.ref('notifications').orderByChild('lng').equalTo(i18next.language).limitToLast(20).on('value', snapshot => {
                    const newNotifications = [];
                    snapshot.forEach((snap) => {
                         newNotifications.push(snap.val());
                    })
                    setNotifications(newNotifications);
                });
            } catch (e) {
                console.log(e.message)
            }
        })();
    }, []);

    return (
        <div className='lng-dir'>
            {
                notifications.map((item, index) => (
                    <NotificationContainer key={index}>
                        <p className='mb-0'>{item.message}</p>
                    </NotificationContainer>
                ))
            }
        </div>
    );
};

export default NotificationsMenu;
